import * as stylex from "@stylexjs/stylex";
import { Children, cloneElement, forwardRef, isValidElement } from "react";
import { useRTL } from "../hooks";
import { breakpoints, colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const stylexStyles = {
    root: {
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kmVPX3: "x1arfzav",
        k3XXqK: "x1t137rt",
        kkrTdU: "x1ypdohk",
        kjj79g: "xl56j7k",
        kGNEyG: "x6s0dn4",
        kg5iWk: "xlyipyv",
        khDVqt: "xuxw1ft",
        kVQacm: "xb3r6kr",
        khiITx: "x1e8rmrl",
        kTUp5R: "x1tea8nt",
        k3lkva: "x1lugfcp",
        k7Eaqz: "x15x72sd x1bun53l",
        $$css: true
    },
    invertedTrue: {
        kWkggS: "x1kf733v",
        kMwMTN: "x12klvby",
        kVAM5u: "x5snjlz",
        $$css: true
    },
    invertedFalse: {
        kWkggS: "x6e1os3",
        kMwMTN: "x1vc0dw",
        kVAM5u: "x1wzfk3z",
        $$css: true
    },
    roundedTrue: {
        kaIpWk: "x12oqio5",
        $$css: true
    },
    roundedFalse: {
        kaIpWk: "x2u8bby",
        $$css: true
    },
    inlineTrue: {
        kzqmXN: "x14atkfc",
        kzQI83: "x1c4vz4f",
        $$css: true
    },
    inlineFalse: {
        kzqmXN: "xh8yej3",
        kzQI83: "x1iyjqo2",
        $$css: true
    },
    hoverInverted: {
        kGzVvX: "x268jtm",
        kDPRdz: "x9a8edp",
        kgXfhb: "xirilg",
        kGatDN: "x1bmzki9",
        k7wbUo: "xxcf5jd",
        kL3a3j: "xum32in",
        kabz5l: "x19q8nkx",
        kqgzUK: "x15n0cyz",
        kvsIF2: "xvjwq26",
        khWSgi: "xcfxubj",
        $$css: true
    },
    hoverNotInverted: {
        kGzVvX: "x57yxf0",
        kDPRdz: "x1ffd3a",
        kgXfhb: "x9uag24",
        kGatDN: "x7w6uxp",
        k7wbUo: "x1qqiywu",
        kL3a3j: "xsszl1e",
        kabz5l: "x16eaa02",
        kqgzUK: "x1x0poz6",
        kvsIF2: "x1vnlbwy",
        khWSgi: "x1nw9049",
        $$css: true
    },
    ghostTrue: {
        kMzoRj: "xc342km",
        kWkggS: "xjbqb8w",
        k1xSpc: "x78zum5",
        $$css: true
    },
    ghostHover: {
        kGzVvX: "x1n5bzlp",
        kL3a3j: "xyc4ar7",
        $$css: true
    },
    groupBorderNoneLtr: {
        kZ1KPB: "xyj58a3",
        $$css: true
    },
    groupBorderNoneRtl: {
        kWqL5O: "xgfja2r",
        kZ1KPB: "xe0pwq",
        kaZRDh: "x9huj1p",
        $$css: true
    },
    groupRoundFirstLtr: {
        kIxVMA: "x2b5lcy",
        kqGeR4: "x1orjc0r",
        $$css: true
    },
    groupRoundFirstRtl: {
        ksF3WI: "x1lzl9kk",
        kYm2EN: "x1nhu2vm",
        kIxVMA: "x1ia1hqs",
        kqGeR4: "xfrllxf",
        $$css: true
    },
    groupRoundLastLtr: {
        ksF3WI: "x1lzl9kk",
        kYm2EN: "x1nhu2vm",
        $$css: true
    },
    groupRoundLastRtl: {
        kIxVMA: "x2b5lcy",
        kqGeR4: "x1orjc0r",
        ksF3WI: "x1a2w583",
        kYm2EN: "xjppbhk",
        $$css: true
    }
};
export const ButtonGroup = ({ children })=>{
    const childArray = Children.toArray(children);
    return <div className="x78zum5 x1iyjqo2 x10w6t97 x193iq5w x1e56ztr">
      {childArray.map((child, i)=>isValidElement(child) ? cloneElement(child, {
            groupIsFirst: i === 0,
            groupIsLast: i === childArray.length - 1
        }) : child)}
    </div>;
};
export const Button = forwardRef((props, ref)=>{
    const isRTL = useRTL();
    const title = typeof props.children === "string" ? props.children : undefined;
    const isGrouped = props.groupIsFirst !== undefined;
    const buttonProps = stylex.props(typography.button, stylexStyles.root, props.inverted ? stylexStyles.invertedTrue : stylexStyles.invertedFalse, props.rounded ? stylexStyles.roundedTrue : stylexStyles.roundedFalse, props.inline ? stylexStyles.inlineTrue : stylexStyles.inlineFalse, props.inverted ? stylexStyles.hoverInverted : stylexStyles.hoverNotInverted, props.ghost && stylexStyles.ghostTrue, props.ghost && stylexStyles.ghostHover, isGrouped && !props.groupIsFirst && (isRTL ? stylexStyles.groupBorderNoneRtl : stylexStyles.groupBorderNoneLtr), isGrouped && props.groupIsFirst && (isRTL ? stylexStyles.groupRoundFirstRtl : stylexStyles.groupRoundFirstLtr), isGrouped && props.groupIsLast && (isRTL ? stylexStyles.groupRoundLastRtl : stylexStyles.groupRoundLastLtr));
    return <button ref={ref} type="button" className={props.className ? `${props.className} ${buttonProps.className}` : buttonProps.className} style={props.style ? {
        ...buttonProps.style,
        ...props.style
    } : buttonProps.style} onClick={props.onClick} title={title}>
      {props.children}
    </button>;
});
export function ButtonGroupAuto({ items, selectedItem, onChange }) {
    return <ButtonGroup>
      {items.map((item)=><Button key={item.value} inverted={selectedItem !== item.value} onClick={()=>onChange(item)}>
          {item.label}
        </Button>)}
    </ButtonGroup>;
}
